import {
    Box,
    FormControl,
    MenuItem,
    Select,
    SelectChangeEvent,
    Typography,
    styled,
    IconButton,
} from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import * as React from "react";
import { useEffect, useState } from "react";
import { apiRequest } from "../../../api/ApiCall";
import { userLogging } from "../../../utility/firestore";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import {
    StoreOpeningConditionsTypeList,
    StoreOpeningConditionsBooleanTypeList,
    StoreOpeningConditionsStringTypeList,
    initStoreOpeningConditionsCommentTextFieldObj,
    initStoreOpeningConditionsReadOnlyObj,
    initStoreOpeningConditionsShowEditIconObj,
    initStoreOpeningConditionsShowIconObj,
} from "../../../data/type";
import {
    setSaveStatus, 
    setDeleteRequestErrorList,
} from "../../../features/longPageSlice";
import {
    setObjStoreOpeningConditions,
    setStoreOpeningConditionsShowAddItems,
} from "../../../features/storeOpeningConditionsSlice";
import { useUserContext } from "../../../user-provider";
import { useUtilityContext } from "../../../utility-provider";
import { LOCAL_CONSTANT } from "../../Const";
import InputWithIcons from "../../components/InputWithIcons";
import {
    chatBubbleErrorSx,
    chatBubbleIconSx,
    editIconCircleSx,
    iconHover,
} from "../../components/ChatBubbleAndEditIconStyle";
import { setPermissionFunc } from "../../components/PermissionFunc";
import ChatBubbleIcon from "@mui/icons-material/ChatBubble";
import EditIcon from "@mui/icons-material/Edit";
import DeficiencyCommentRegistModal from "../../components/DeficiencyCommentRegistModal";
import {
    changeTextColor,
    changeNoSubkeyBGColor,
    changeBorderColor
} from "../../../data/tableFunc";
import {
    BorderDefaultColor,
    BorderHoverColor,
    BorderFocusedColor,
    BorderErrorColor
} from "../../../data/table";

//項目値の横幅調整
const itemValueSx = {
    width: "250px",
};

//プルダウン スタイル
const selectStyle = (
    isUserType: boolean,
    objRrBranchLog: any,
    objRequestErrorList: any,
    listDeficiencyComment: any,
    labelName: string,
    value: any
) => {
    //テキストカラー
    const color = changeTextColor(
        isUserType,
        objRrBranchLog,
        LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
        labelName
    );
    //背景
    const backgroundColor = changeNoSubkeyBGColor(
        isUserType,
        objRequestErrorList,
        LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
        labelName,
        value
    );
    //枠線
    const hasBorderColor = changeBorderColor(
        listDeficiencyComment,
        LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
        labelName
    );
    return {
        "& .MuiSelect-select": {
            color: color
        },
        "& .MuiSelect-select.MuiInputBase-input.MuiOutlinedInput-input.Mui-disabled": {
            WebkitTextFillColor: color
        },
        textAlign: "center",
        backgroundColor: backgroundColor,
        "& .MuiOutlinedInput-notchedOutline": {
            borderColor: hasBorderColor ? BorderErrorColor : BorderDefaultColor,
            borderWidth: hasBorderColor ? "3pt" : "1pt"                           //線の幅調整
        },
        "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: hasBorderColor ? BorderErrorColor : BorderHoverColor,    //ホバー時
            borderWidth: hasBorderColor ? "3pt" : "1pt"                           //線の幅調整
        },
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: hasBorderColor ? BorderErrorColor : BorderFocusedColor,  //フォーカス時
            borderWidth: hasBorderColor ? "3pt" : "2pt"                           //線の幅調整

        },
        "&.Mui-disabled .MuiOutlinedInput-notchedOutline": {
            borderColor: hasBorderColor ? BorderErrorColor : BorderDefaultColor,  //非活性時
            borderWidth: hasBorderColor ? "3pt" : "1pt"                           //線の幅調整
        }
    };
};

//ゴンドラ 高さ（mm）のプルダウン値
const gondolaHeightItems: { [key: string]: string } = {
    gondolaHeightItem1: "1350",
    gondolaHeightItem2: "1500",
    gondolaHeightItem3: "1650",
    gondolaHeightItem4: "1800",
};

//アスタリスク
const RedAsterisk = styled("span")({
    color: "red",
    marginLeft: "4px",
    display: "flex",
    alignItems: "center",
});

interface SpecialNotesProps {
    props: {
        storeOpeningConditions: StoreOpeningConditionsTypeList;
        setStoreOpeningConditions: React.Dispatch<
            React.SetStateAction<StoreOpeningConditionsTypeList>
        >;
    };
}

const SpecialNotes: React.FC<SpecialNotesProps> = ({ props }) => {
    const objStoreOpeningConditions = useAppSelector(
        (state) => state.storeOpeningConditions.obj
    );
    //店舗面積の値によって「※店舗面積40坪未満の場合、設備詳細を記入」の項目を表示か非表示
    const showAddItems = useAppSelector(
        (state) => state.storeOpeningConditions.showAddItems
    );
    //ロングページオブジェクト 候補地NOと枝を取得
    const objLongPageParam = useAppSelector((state) => state.longPage.param);
    //ステータス管理sequenceとタスクIDを取得するため
    const objLocationBase = useAppSelector(
        (state) => state.longPage.locationBase
    );
    //パラメーターオブジェクト
    const objLongPageSaveStatus = useAppSelector(
        (state) => state.longPage.saveStatus
    );
    //表示形式変更用BQログデータ
    const objRrBranchLog = useAppSelector(
        (state) => state.longPage.rrBranchLog
    );
    // 入力チェックエラーリスト
    const objRequestErrorList = useAppSelector(
        (state) => state.longPage.requestErrorList
    );
    // 不備コメントリスト
    const listDeficiencyComment = useAppSelector(
        (state) => state.deficiencyComment
    );
    const dispatch = useAppDispatch();

    const [userType, setUserType] = useState("");
    const user = useUserContext();

    const utilityCtx = useUtilityContext();
    //不備コメントモーダルラベル名
    const [labelNameStr, setLabelNameStr] = useState<string>("");
    //不備コメントモーダル開閉フラグ
    const [deficiencyComentModalFlag, setDeficiencyComentModalFlag] =
        useState(false);
    //アイコン全体の表示非表示のステータス
    const [
        storeOpeningConditionsShowIconsObj,
        setStoreOpeningConditionsShowIconsObj,
    ] = useState<StoreOpeningConditionsBooleanTypeList>(
        initStoreOpeningConditionsShowIconObj
    );
    //不備コメントモーダル内、TextFieldのコメント
    const [
        storeOpeningConditionsCommentTextFieldObj,
        setStoreOpeningConditionsCommentTextFieldObj,
    ] = useState<StoreOpeningConditionsStringTypeList>(
        initStoreOpeningConditionsCommentTextFieldObj
    );
    //項目値を編集可能にするステータスの型定義
    const [
        storeOpeningConditionsReadOnlyObj,
        setStoreOpeningConditionsReadOnlyObj,
    ] = useState<StoreOpeningConditionsBooleanTypeList>(
        initStoreOpeningConditionsReadOnlyObj
    );

    //インプット
    const handleInputChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
        labelName: string
    ) => {
        const targetValue = e.target.value; //入力値
        const storeOpeningConditionsValue =
            props.storeOpeningConditions[labelName];
        const regexRange0To9999 = /^(|0|[1-9][0-9]{0,3})$/; //入力規則:整数 範囲:0～9999
        const regexRange0To99Point9 =
            /^(|0|0\.|0\.[0-9]|[1-9][0-9]{0,1}(\.[0-9]{0,1})?|)$/; //入力規則:小数点数 範囲:0～99.9
        const regexRange0TO9999Point99 =
            /^(|0|0\.|0\.0|0\.[0-9][0-9]?|[1-9][0-9]{0,3}(\.[0-9]{0,2})?)$/; //入力規則:小数点数 範囲:0～9999.99

        switch (labelName) {
            case "store_frontage": // 店舗間口
                if (regexRange0To99Point9.test(targetValue)) {
                    props.setStoreOpeningConditions({
                        ...props.storeOpeningConditions,
                        [labelName]: targetValue,
                    });
                    break;
                } else {
                    props.setStoreOpeningConditions({
                        ...props.storeOpeningConditions,
                        [labelName]: storeOpeningConditionsValue,
                    });
                    break;
                }
            case "store_area": // 店舗面積
                if (regexRange0TO9999Point99.test(targetValue)) {
                    props.setStoreOpeningConditions({
                        ...props.storeOpeningConditions,
                        [labelName]: targetValue,
                    });
                    break;
                } else {
                    props.setStoreOpeningConditions({
                        ...props.storeOpeningConditions,
                        [labelName]: storeOpeningConditionsValue,
                    });
                    break;
                }
            case "salses_area": // 売場
                if (regexRange0TO9999Point99.test(targetValue)) {
                    props.setStoreOpeningConditions({
                        ...props.storeOpeningConditions,
                        [labelName]: targetValue,
                    });
                    break;
                } else {
                    props.setStoreOpeningConditions({
                        ...props.storeOpeningConditions,
                        [labelName]: storeOpeningConditionsValue,
                    });
                    break;
                }
            case "open_case": // オープンケース
                if (regexRange0To9999.test(targetValue)) {
                    props.setStoreOpeningConditions({
                        ...props.storeOpeningConditions,
                        [labelName]: targetValue,
                    });
                    break;
                } else {
                    props.setStoreOpeningConditions({
                        ...props.storeOpeningConditions,
                        [labelName]: storeOpeningConditionsValue,
                    });
                    break;
                }
            case "nakajima_chilled": // 中島チルド
                if (regexRange0To9999.test(targetValue)) {
                    props.setStoreOpeningConditions({
                        ...props.storeOpeningConditions,
                        [labelName]: targetValue,
                    });
                    break;
                } else {
                    props.setStoreOpeningConditions({
                        ...props.storeOpeningConditions,
                        [labelName]: storeOpeningConditionsValue,
                    });
                    break;
                }
            case "island_chilled": // アイランドチルド
                if (regexRange0To9999.test(targetValue)) {
                    props.setStoreOpeningConditions({
                        ...props.storeOpeningConditions,
                        [labelName]: targetValue,
                    });
                    break;
                } else {
                    props.setStoreOpeningConditions({
                        ...props.storeOpeningConditions,
                        [labelName]: storeOpeningConditionsValue,
                    });
                    break;
                }
            case "gondola_units": // ゴンドラ尺数
                if (regexRange0To9999.test(targetValue)) {
                    props.setStoreOpeningConditions({
                        ...props.storeOpeningConditions,
                        [labelName]: targetValue,
                    });
                    break;
                } else {
                    props.setStoreOpeningConditions({
                        ...props.storeOpeningConditions,
                        [labelName]: storeOpeningConditionsValue,
                    });
                    break;
                }
            case "ice_case_large": // アイスケース 大
                if (regexRange0To9999.test(targetValue)) {
                    props.setStoreOpeningConditions({
                        ...props.storeOpeningConditions,
                        [labelName]: targetValue,
                    });
                    break;
                } else {
                    props.setStoreOpeningConditions({
                        ...props.storeOpeningConditions,
                        [labelName]: storeOpeningConditionsValue,
                    });
                    break;
                }
            case "ice_case_medium": // アイスケース 中
                if (regexRange0To9999.test(targetValue)) {
                    props.setStoreOpeningConditions({
                        ...props.storeOpeningConditions,
                        [labelName]: targetValue,
                    });
                    break;
                } else {
                    props.setStoreOpeningConditions({
                        ...props.storeOpeningConditions,
                        [labelName]: storeOpeningConditionsValue,
                    });
                    break;
                }
            case "ice_case_small": // アイスケース 小
                if (regexRange0To9999.test(targetValue)) {
                    props.setStoreOpeningConditions({
                        ...props.storeOpeningConditions,
                        [labelName]: targetValue,
                    });
                    break;
                } else {
                    props.setStoreOpeningConditions({
                        ...props.storeOpeningConditions,
                        [labelName]: storeOpeningConditionsValue,
                    });
                    break;
                }
            case "compact_stocker": // コンパクトストッカー
                if (regexRange0To9999.test(targetValue)) {
                    props.setStoreOpeningConditions({
                        ...props.storeOpeningConditions,
                        [labelName]: targetValue,
                    });
                    break;
                } else {
                    props.setStoreOpeningConditions({
                        ...props.storeOpeningConditions,
                        [labelName]: storeOpeningConditionsValue,
                    });
                    break;
                }
            case "low_temp_reach_in": // 低温リーチイン
                if (regexRange0To9999.test(targetValue)) {
                    props.setStoreOpeningConditions({
                        ...props.storeOpeningConditions,
                        [labelName]: targetValue,
                    });
                    break;
                } else {
                    props.setStoreOpeningConditions({
                        ...props.storeOpeningConditions,
                        [labelName]: storeOpeningConditionsValue,
                    });
                    break;
                }
            case "walk_in": // ウォークイン
                if (regexRange0To9999.test(targetValue)) {
                    props.setStoreOpeningConditions({
                        ...props.storeOpeningConditions,
                        [labelName]: targetValue,
                    });
                    break;
                } else {
                    props.setStoreOpeningConditions({
                        ...props.storeOpeningConditions,
                        [labelName]: storeOpeningConditionsValue,
                    });
                    break;
                }
            case "conter_width": // カウンター幅
                if (regexRange0TO9999Point99.test(targetValue)) {
                    props.setStoreOpeningConditions({
                        ...props.storeOpeningConditions,
                        [labelName]: targetValue,
                    });
                    break;
                } else {
                    props.setStoreOpeningConditions({
                        ...props.storeOpeningConditions,
                        [labelName]: storeOpeningConditionsValue,
                    });
                    break;
                }
            default:
                props.setStoreOpeningConditions({
                    ...props.storeOpeningConditions,
                    [labelName]: targetValue,
                });
                break;
        }

        //更新フラグ
        if (!objLongPageSaveStatus.StoreOpeningConditions)
            dispatch(
                setSaveStatus({
                    ...objLongPageSaveStatus,
                    StoreOpeningConditions: true,
                })
            );
    };

    //Redux プルダウン
    const handleSelectChange = (
        e: SelectChangeEvent<string>,
        labelName: string
    ) => {
        // 入力した値をStoreへ登録する
        dispatch(
            setObjStoreOpeningConditions({
                ...objStoreOpeningConditions,
                [labelName]: e.target.value,
            })
        );
        //更新フラグ
        if (!objLongPageSaveStatus.StoreOpeningConditions)
            dispatch(
                setSaveStatus({
                    ...objLongPageSaveStatus,
                    StoreOpeningConditions: true,
                })
            );
        //入力チェックのエラーリストから削除
        if (objRequestErrorList.length > 0)
            dispatch(
                setDeleteRequestErrorList({
                    page: LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                    column: labelName,
                })
            );
    };

    //インプットをクリックしたときアイコンを表示
    const handleInputClick = (labelName: string) => {
        setStoreOpeningConditionsShowIconsObj({
            ...storeOpeningConditionsShowIconsObj,
            [labelName]: true,
        });
    };

    //吹き出しをクリックしたとき、モーダル画面を開く
    const handleChatBubbleClick = (labelName: string) => {
        setLabelNameStr(labelName);
        setDeficiencyComentModalFlag(true);
        setStoreOpeningConditionsCommentTextFieldObj({
            ...storeOpeningConditionsCommentTextFieldObj,
            [labelName]: "",
        }); //テキストフィールドのコメントを初期化
    };

    //鉛筆をクリックしたとき、Input編集可
    const handleEditIconClick = (labelName: string) => {
        if (
            setPermissionFunc(
                userType,
                objLocationBase.task_id,
                LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                labelName
            ) === false
        ) {
            //falseにすると、Input編集可
            setStoreOpeningConditionsReadOnlyObj({
                ...storeOpeningConditionsReadOnlyObj,
                [labelName]: false,
            });
        }
    };

    //不備コメントモーダル内でのコメント取得
    const handleCommentChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
        labelName: string
    ) => {
        setStoreOpeningConditionsCommentTextFieldObj({
            ...storeOpeningConditionsCommentTextFieldObj,
            [labelName]: e.target.value,
        });
    };

    //不備コメントモーダル内の保存ボタンをクリックしたときコメントを保存
    const handleSaveComment = async (labelName: string) => {
        //不備コメントを登録
        const params = {
            mode: "regist",
            endPoint: "/location/Deficiency/v1/regist",
            query: {
                plan_area_id: objLongPageParam.planAreaId,
                branch: objLongPageParam.branch,
                status_seq: objLocationBase.status_seq,
                table_name: LOCAL_CONSTANT.TABLE.STORE_OPENING_CONDITIONS,
                column_name: labelName,
                comment: storeOpeningConditionsCommentTextFieldObj[labelName],
                sub_key: LOCAL_CONSTANT.DEFICIENCY.DEFAULT_SUB_KEY
            },
        };
        userLogging(
            LOCAL_CONSTANT.FUNCTION_NAME.SPECIAL_NOTES_COMMENT,
            params,
            user
        );
        if (utilityCtx.showSpinner) {
            utilityCtx.showSpinner();
        }
        try {
            await apiRequest(params);
            if (utilityCtx.hideSpinner) {
                utilityCtx.hideSpinner();
            }
            //不備コメントモーダルを閉じる
            setDeficiencyComentModalFlag(false);
            //アイコンを非表示
            setStoreOpeningConditionsShowIconsObj({
                ...storeOpeningConditionsShowIconsObj,
                [labelName]: false,
            });
        } catch (e) {
            console.log(e);
            if (utilityCtx.hideSpinner) {
                utilityCtx.hideSpinner();
            }
            //不備コメントモーダルを閉じる
            setDeficiencyComentModalFlag(false);
            //アイコンを非表示
            setStoreOpeningConditionsShowIconsObj({
                ...storeOpeningConditionsShowIconsObj,
                [labelName]: false,
            });
        }
    };

    // インプットからフォーカスがずれたら、インプット編集不可とアイコンを非表示にする
    const handleInputBlur = (
        e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement, Element>,
        labelName: string
    ) => {
        //Reduxへ保存
        dispatch(
            setObjStoreOpeningConditions({
                ...props.storeOpeningConditions,
                [labelName]: e.target.value,
            })
        );

        //入力チェックのエラーリストから削除
        if (objRequestErrorList.length > 0)
            dispatch(
                setDeleteRequestErrorList({
                    page: LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                    column: labelName,
                })
            );

        // インプット編集不可
        setStoreOpeningConditionsReadOnlyObj({
            ...storeOpeningConditionsReadOnlyObj,
            [labelName]: true,
        });

        //フォーカスが外れたとき、空白でないかつ入力された値が132.22以下の場合に追加項目を表示
        if (labelName === "store_area") {
            //店舗面積
            dispatch(
                setStoreOpeningConditionsShowAddItems(
                    props.storeOpeningConditions.store_area !== "" &&
                    Number(props.storeOpeningConditions.store_area) < 132.23
                )
            );
        }

        //インプットからフォーカスが移動する先がnullの場合アイコンを閉じる
        if (!e.relatedTarget) {
            setStoreOpeningConditionsShowIconsObj({
                ...storeOpeningConditionsShowIconsObj,
                [labelName]: false,
            });
        }

        //インプットからフォーカスが移動する先がインプットタグの場合アイコンを閉じる
        if (e.relatedTarget && e.relatedTarget.tagName === "INPUT") {
            setStoreOpeningConditionsShowIconsObj({
                ...storeOpeningConditionsShowIconsObj,
                [labelName]: false,
            });
        }

        //テキストエリアからフォーカスが移動する先がテキストエリアタグの場合アイコンを閉じる
        if (e.relatedTarget && e.relatedTarget.tagName === "TEXTAREA") {
            setStoreOpeningConditionsShowIconsObj({
                ...storeOpeningConditionsShowIconsObj,
                [labelName]: false,
            });
        }
    };

    //ユーザー取得タイミングによる画面制御
    useEffect(() => {
        if (JSON.parse(user.userData || "null") !== null) {
            setUserType(JSON.parse(user.userData || "null").user_type);
        }
    }, [user]);

    useEffect(() => {
        //ReduxをuseStateに保存
        props.setStoreOpeningConditions(objStoreOpeningConditions);
        // 店舗面積が空でなく、かつ入力された値が132.22以下の場合は要素を表示
        dispatch(
            setStoreOpeningConditionsShowAddItems(
                objStoreOpeningConditions.store_area !== "" &&
                Number(objStoreOpeningConditions.store_area) < 132.23
            )
        );
    }, [objStoreOpeningConditions]);

    //不備コメントモーダルを閉じたときに、吹き出しと鉛筆アイコンを非表示
    useEffect(() => {
        if (!deficiencyComentModalFlag) {
            setStoreOpeningConditionsShowIconsObj({
                ...initStoreOpeningConditionsShowIconObj
            });
        }
    }, [deficiencyComentModalFlag]);

    return (
        <Box>
            <Typography component="h2" mt={2}>特記事項</Typography>

            <Grid container spacing={2} maxWidth="lg">
                <Grid xs={12} md={6}>
                    <Grid container spacing={2} alignItems="center">
                        <Grid>
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    width: "180px",
                                }}
                            >
                                <Typography>店舗間口</Typography>
                                <RedAsterisk>＊＊</RedAsterisk>
                            </Box>
                        </Grid>
                        <Grid sx={itemValueSx}>
                            <InputWithIcons
                                props={{
                                    userType: userType, //ユーザー
                                    disabled: setPermissionFunc(
                                        userType,
                                        objLocationBase.task_id,
                                        LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                        "store_frontage"
                                    ), //ユーザー権限
                                    pageName: LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                    labelName: "store_frontage",
                                    startAdornment: "",
                                    endAdornment: "m",
                                    InputValueObj: props.storeOpeningConditions,
                                    ReadOnlyObj: storeOpeningConditionsReadOnlyObj,
                                    setReadOnlyObj: setStoreOpeningConditionsReadOnlyObj,
                                    ShowEditIconObj: initStoreOpeningConditionsShowEditIconObj,
                                    ShowIconsObj: storeOpeningConditionsShowIconsObj,
                                    handleChatBubbleClick: handleChatBubbleClick,
                                    handleInputBlur: handleInputBlur,
                                    handleInputChange: handleInputChange,
                                    handleInputClick: handleInputClick,
                                }}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid xs={12} md={6}>
                    <Grid container spacing={2} alignItems="center">
                        <Grid>
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    width: "180px",
                                }}
                            >
                                <Typography>店舗面積</Typography>
                                <RedAsterisk>＊＊</RedAsterisk>
                            </Box>
                        </Grid>
                        <Grid sx={itemValueSx}>
                            <InputWithIcons
                                props={{
                                    userType: userType, //ユーザー
                                    disabled: setPermissionFunc(
                                        userType,
                                        objLocationBase.task_id,
                                        LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                        "store_area"
                                    ), //ユーザー権限
                                    pageName: LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                    labelName: "store_area",
                                    startAdornment: "",
                                    endAdornment: "㎡",
                                    InputValueObj: props.storeOpeningConditions,
                                    ReadOnlyObj: storeOpeningConditionsReadOnlyObj,
                                    setReadOnlyObj: setStoreOpeningConditionsReadOnlyObj,
                                    ShowEditIconObj: initStoreOpeningConditionsShowEditIconObj,
                                    ShowIconsObj: storeOpeningConditionsShowIconsObj,
                                    handleChatBubbleClick: handleChatBubbleClick,
                                    handleInputBlur: handleInputBlur,
                                    handleInputChange: handleInputChange,
                                    handleInputClick: handleInputClick,
                                }}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

            <Grid container spacing={2} maxWidth="lg">
                <Grid xs={12} md={6}>
                    <Grid container spacing={2} alignItems="center">
                        <Grid>
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    width: "180px",
                                }}
                            >
                                <Typography>売場面積</Typography>
                                <RedAsterisk>＊</RedAsterisk>
                            </Box>
                        </Grid>
                        <Grid sx={itemValueSx}>
                            <InputWithIcons
                                props={{
                                    userType: userType, //ユーザー
                                    disabled: setPermissionFunc(
                                        userType,
                                        objLocationBase.task_id,
                                        LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                        "salses_area"
                                    ), //ユーザー権限
                                    pageName: LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                    labelName: "salses_area",
                                    startAdornment: "",
                                    endAdornment: "㎡",
                                    InputValueObj: props.storeOpeningConditions,
                                    ReadOnlyObj: storeOpeningConditionsReadOnlyObj,
                                    setReadOnlyObj: setStoreOpeningConditionsReadOnlyObj,
                                    ShowEditIconObj: initStoreOpeningConditionsShowEditIconObj,
                                    ShowIconsObj: storeOpeningConditionsShowIconsObj,
                                    handleChatBubbleClick: handleChatBubbleClick,
                                    handleInputBlur: handleInputBlur,
                                    handleInputChange: handleInputChange,
                                    handleInputClick: handleInputClick,
                                }}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid xs={12} md={6}></Grid>
            </Grid>

            {/* 店舗面積が空でなく、かつ入力された値が132.22以下の場合は要素を表示 */}
            {/* ※店舗面積40坪未満の場合、設備詳細を記入 */}
            {showAddItems && (
                <Box>
                    <Typography component="h2" mt={2}>
                        ※店舗面積40坪未満の場合、設備詳細を記入
                    </Typography>

                    <Grid container spacing={2} maxWidth="lg">
                        <Grid xs={12} md={6}>
                            <Grid container spacing={2} alignItems="center">
                                <Grid>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            width: "180px",
                                        }}
                                    >
                                        <Typography>オープンケース</Typography>
                                        <RedAsterisk>＊＊</RedAsterisk>
                                    </Box>
                                </Grid>
                                <Grid sx={itemValueSx}>
                                    <InputWithIcons
                                        props={{
                                            userType: userType, //ユーザー
                                            disabled: setPermissionFunc(
                                                userType,
                                                objLocationBase.task_id,
                                                LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                                "open_case"
                                            ), //ユーザー権限
                                            pageName: LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                            labelName: "open_case",
                                            startAdornment: "",
                                            endAdornment: "台",
                                            InputValueObj: props.storeOpeningConditions,
                                            ReadOnlyObj: storeOpeningConditionsReadOnlyObj,
                                            setReadOnlyObj: setStoreOpeningConditionsReadOnlyObj,
                                            ShowEditIconObj: initStoreOpeningConditionsShowEditIconObj,
                                            ShowIconsObj: storeOpeningConditionsShowIconsObj,
                                            handleChatBubbleClick: handleChatBubbleClick,
                                            handleInputBlur: handleInputBlur,
                                            handleInputChange: handleInputChange,
                                            handleInputClick: handleInputClick,
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid xs={12} md={6}>
                            <Grid container spacing={2} alignItems="center">
                                <Grid>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            width: "180px",
                                        }}
                                    >
                                        <Typography>中島チルド</Typography>
                                        <RedAsterisk>＊＊</RedAsterisk>
                                    </Box>
                                </Grid>
                                <Grid sx={itemValueSx}>
                                    <InputWithIcons
                                        props={{
                                            userType: userType, //ユーザー
                                            disabled: setPermissionFunc(
                                                userType,
                                                objLocationBase.task_id,
                                                LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                                "nakajima_chilled"
                                            ), //ユーザー権限
                                            pageName: LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                            labelName: "nakajima_chilled",
                                            startAdornment: "",
                                            endAdornment: "台",
                                            InputValueObj: props.storeOpeningConditions,
                                            ReadOnlyObj: storeOpeningConditionsReadOnlyObj,
                                            setReadOnlyObj: setStoreOpeningConditionsReadOnlyObj,
                                            ShowEditIconObj: initStoreOpeningConditionsShowEditIconObj,
                                            ShowIconsObj: storeOpeningConditionsShowIconsObj,
                                            handleChatBubbleClick: handleChatBubbleClick,
                                            handleInputBlur: handleInputBlur,
                                            handleInputChange: handleInputChange,
                                            handleInputClick: handleInputClick,
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid container spacing={2} maxWidth="lg">
                        <Grid xs={12} md={6}>
                            <Grid container spacing={2} alignItems="center">
                                <Grid>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            width: "180px",
                                        }}
                                    >
                                        <Typography>アイランドチルド</Typography>
                                        <RedAsterisk>＊＊</RedAsterisk>
                                    </Box>
                                </Grid>
                                <Grid sx={itemValueSx}>
                                    <InputWithIcons
                                        props={{
                                            userType: userType, //ユーザー
                                            disabled: setPermissionFunc(
                                                userType,
                                                objLocationBase.task_id,
                                                LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                                "island_chilled"
                                            ), //ユーザー権限
                                            pageName: LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                            labelName: "island_chilled",
                                            startAdornment: "",
                                            endAdornment: "台",
                                            InputValueObj: props.storeOpeningConditions,
                                            ReadOnlyObj: storeOpeningConditionsReadOnlyObj,
                                            setReadOnlyObj: setStoreOpeningConditionsReadOnlyObj,
                                            ShowEditIconObj: initStoreOpeningConditionsShowEditIconObj,
                                            ShowIconsObj: storeOpeningConditionsShowIconsObj,
                                            handleChatBubbleClick: handleChatBubbleClick,
                                            handleInputBlur: handleInputBlur,
                                            handleInputChange: handleInputChange,
                                            handleInputClick: handleInputClick,
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid xs={12} md={6}></Grid>
                    </Grid>

                    <Grid container spacing={2} maxWidth="lg">
                        <Grid xs={12} md={6}>
                            <Grid container spacing={2} alignItems="center">
                                <Grid sx={{ width: "120px" }}>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                        }}
                                    >
                                        <Typography>ゴンドラ</Typography>
                                        <Typography
                                            style={{ marginLeft: "7px" }}
                                        >
                                            尺数
                                        </Typography>
                                    </Box>
                                </Grid>
                                <Grid>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            width: "60px",
                                        }}
                                    >
                                        <RedAsterisk>＊＊</RedAsterisk>
                                    </Box>
                                </Grid>
                                <Grid sx={itemValueSx}>
                                    <InputWithIcons
                                        props={{
                                            userType: userType, //ユーザー
                                            disabled: setPermissionFunc(
                                                userType,
                                                objLocationBase.task_id,
                                                LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                                "gondola_units"
                                            ), //ユーザー権限
                                            pageName: LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                            labelName: "gondola_units",
                                            startAdornment: "",
                                            endAdornment: "尺",
                                            InputValueObj: props.storeOpeningConditions,
                                            ReadOnlyObj: storeOpeningConditionsReadOnlyObj,
                                            setReadOnlyObj: setStoreOpeningConditionsReadOnlyObj,
                                            ShowEditIconObj: initStoreOpeningConditionsShowEditIconObj,
                                            ShowIconsObj: storeOpeningConditionsShowIconsObj,
                                            handleChatBubbleClick: handleChatBubbleClick,
                                            handleInputBlur: handleInputBlur,
                                            handleInputChange: handleInputChange,
                                            handleInputClick: handleInputClick,
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid xs={12} md={6}>
                            <Grid container spacing={2} alignItems="center">
                                <Grid>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            width: "180px",
                                        }}
                                    >
                                        <Typography>高さ（mm）</Typography>
                                        <RedAsterisk>＊＊</RedAsterisk>
                                    </Box>
                                </Grid>
                                <Box display="flex" alignItems="center">
                                    <Grid sx={itemValueSx}>
                                        <FormControl fullWidth>
                                            <Select
                                                onChange={(e) => handleSelectChange(e, "gondola_height")}
                                                value={objStoreOpeningConditions.gondola_height}
                                                sx={selectStyle(
                                                    userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                        ? setPermissionFunc(
                                                            userType,
                                                            objLocationBase.task_id,
                                                            LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                                            "gondola_height"
                                                        )
                                                        : storeOpeningConditionsReadOnlyObj.gondola_height,
                                                    objRrBranchLog,
                                                    objRequestErrorList,
                                                    listDeficiencyComment,
                                                    "gondola_height",
                                                    objStoreOpeningConditions.gondola_height
                                                )}
                                                disabled={
                                                    userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                        ? setPermissionFunc(
                                                            userType,
                                                            objLocationBase.task_id,
                                                            LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                                            "gondola_height"
                                                        )
                                                        : storeOpeningConditionsReadOnlyObj.gondola_height
                                                }
                                            >
                                                {Object.keys(
                                                    gondolaHeightItems
                                                ).map((key) => (
                                                    <MenuItem key={key} value={gondolaHeightItems[key]}>
                                                        {gondolaHeightItems[key]}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    {/* RFCの場合、不備コメント 吹き出しアイコンを表示 */}
                                    {/* RRの場合、不備コメント 吹き出しと編集アイコンを表示 */}
                                    {LOCAL_CONSTANT.USER_TYPE.RFC_RR.includes(userType) && (
                                        <Grid sx={{ width: "120px" }}>
                                            <IconButton
                                                disabled={setPermissionFunc(
                                                    userType,
                                                    objLocationBase.task_id,
                                                    LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                                    "gondola_height"
                                                )}
                                                onClick={() => {handleChatBubbleClick("gondola_height");}}
                                                sx={iconHover}
                                            >
                                                <Box
                                                    sx={chatBubbleErrorSx(
                                                        userType,
                                                        objLocationBase.task_id,
                                                        LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                                        "gondola_height",
                                                        listDeficiencyComment
                                                    )}
                                                >
                                                    <ChatBubbleIcon
                                                        sx={chatBubbleIconSx}
                                                    />
                                                </Box>
                                            </IconButton>
                                            {userType === LOCAL_CONSTANT.USER_TYPE.RR && (
                                                <IconButton
                                                    onClick={() => {handleEditIconClick("gondola_height");}}
                                                    sx={iconHover}
                                                >
                                                    <Box sx={editIconCircleSx}>
                                                        <EditIcon />
                                                    </Box>
                                                </IconButton>
                                            )}
                                        </Grid>
                                    )}
                                </Box>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid container spacing={2} maxWidth="lg">
                        <Grid xs={12} md={6}>
                            <Grid container spacing={2} alignItems="center">
                                <Grid sx={{ width: "120px" }}>
                                    <Typography>アイスケース</Typography>
                                </Grid>
                                <Grid>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            width: "60px",
                                        }}
                                    >
                                        <Typography>大</Typography>
                                        <RedAsterisk>＊＊</RedAsterisk>
                                    </Box>
                                </Grid>
                                <Grid sx={itemValueSx}>
                                    <InputWithIcons
                                        props={{
                                            userType: userType, //ユーザー
                                            disabled: setPermissionFunc(
                                                userType,
                                                objLocationBase.task_id,
                                                LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                                "ice_case_large"
                                            ), //ユーザー権限
                                            pageName: LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                            labelName: "ice_case_large",
                                            startAdornment: "",
                                            endAdornment: "台",
                                            InputValueObj: props.storeOpeningConditions,
                                            ReadOnlyObj: storeOpeningConditionsReadOnlyObj,
                                            setReadOnlyObj: setStoreOpeningConditionsReadOnlyObj,
                                            ShowEditIconObj: initStoreOpeningConditionsShowEditIconObj,
                                            ShowIconsObj: storeOpeningConditionsShowIconsObj,
                                            handleChatBubbleClick: handleChatBubbleClick,
                                            handleInputBlur: handleInputBlur,
                                            handleInputChange: handleInputChange,
                                            handleInputClick: handleInputClick,
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid xs={12} md={6}>
                            <Grid container spacing={2} alignItems="center">
                                <Grid>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            width: "180px",
                                        }}
                                    >
                                        <Typography>中</Typography>
                                        <RedAsterisk>＊＊</RedAsterisk>
                                    </Box>
                                </Grid>
                                <Grid sx={itemValueSx}>
                                    <InputWithIcons
                                        props={{
                                            userType: userType, //ユーザー
                                            disabled: setPermissionFunc(
                                                userType,
                                                objLocationBase.task_id,
                                                LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                                "ice_case_medium"
                                            ), //ユーザー権限
                                            pageName: LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                            labelName: "ice_case_medium",
                                            startAdornment: "",
                                            endAdornment: "台",
                                            InputValueObj: props.storeOpeningConditions,
                                            ReadOnlyObj: storeOpeningConditionsReadOnlyObj,
                                            setReadOnlyObj: setStoreOpeningConditionsReadOnlyObj,
                                            ShowEditIconObj: initStoreOpeningConditionsShowEditIconObj,
                                            ShowIconsObj: storeOpeningConditionsShowIconsObj,
                                            handleChatBubbleClick: handleChatBubbleClick,
                                            handleInputBlur: handleInputBlur,
                                            handleInputChange: handleInputChange,
                                            handleInputClick: handleInputClick,
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid container spacing={2} maxWidth="lg">
                        <Grid xs={12} md={6}>
                            <Grid container spacing={2} alignItems="center">
                                <Grid sx={{ width: "120px" }}></Grid>
                                <Grid>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            width: "60px",
                                        }}
                                    >
                                        <Typography>小</Typography>
                                        <RedAsterisk>＊＊</RedAsterisk>
                                    </Box>
                                </Grid>
                                <Grid sx={itemValueSx}>
                                    <InputWithIcons
                                        props={{
                                            userType: userType, //ユーザー
                                            disabled: setPermissionFunc(
                                                userType,
                                                objLocationBase.task_id,
                                                LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                                "ice_case_small"
                                            ), //ユーザー権限
                                            pageName: LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                            labelName: "ice_case_small",
                                            startAdornment: "",
                                            endAdornment: "台",
                                            InputValueObj: props.storeOpeningConditions,
                                            ReadOnlyObj: storeOpeningConditionsReadOnlyObj,
                                            setReadOnlyObj: setStoreOpeningConditionsReadOnlyObj,
                                            ShowEditIconObj: initStoreOpeningConditionsShowEditIconObj,
                                            ShowIconsObj: storeOpeningConditionsShowIconsObj,
                                            handleChatBubbleClick: handleChatBubbleClick,
                                            handleInputBlur: handleInputBlur,
                                            handleInputChange: handleInputChange,
                                            handleInputClick: handleInputClick,
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid container spacing={2} maxWidth="lg">
                        <Grid xs={12} md={6}>
                            <Grid container spacing={2} alignItems="center">
                                <Grid>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            width: "180px",
                                        }}
                                    >
                                        <Typography>コンパクト<br />ストッカー</Typography>
                                        <RedAsterisk>＊＊</RedAsterisk>
                                    </Box>
                                </Grid>
                                <Grid sx={itemValueSx}>
                                    <InputWithIcons
                                        props={{
                                            userType: userType, //ユーザー
                                            disabled: setPermissionFunc(
                                                userType,
                                                objLocationBase.task_id,
                                                LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                                "compact_stocker"
                                            ), //ユーザー権限
                                            pageName: LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                            labelName: "compact_stocker",
                                            startAdornment: "",
                                            endAdornment: "台",
                                            InputValueObj: props.storeOpeningConditions,
                                            ReadOnlyObj: storeOpeningConditionsReadOnlyObj,
                                            setReadOnlyObj: setStoreOpeningConditionsReadOnlyObj,
                                            ShowEditIconObj: initStoreOpeningConditionsShowEditIconObj,
                                            ShowIconsObj: storeOpeningConditionsShowIconsObj,
                                            handleChatBubbleClick: handleChatBubbleClick,
                                            handleInputBlur: handleInputBlur,
                                            handleInputChange: handleInputChange,
                                            handleInputClick: handleInputClick,
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid xs={12} md={6}>
                            <Grid container spacing={2} alignItems="center">
                                <Grid>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            width: "180px",
                                        }}
                                    >
                                        <Typography>低温リーチイン</Typography>
                                        <RedAsterisk>＊＊</RedAsterisk>
                                    </Box>
                                </Grid>
                                <Grid sx={itemValueSx}>
                                    <InputWithIcons
                                        props={{
                                            userType: userType, //ユーザー
                                            disabled: setPermissionFunc(
                                                userType,
                                                objLocationBase.task_id,
                                                LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                                "low_temp_reach_in"
                                            ), //ユーザー権限
                                            pageName:
                                                LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                            labelName: "low_temp_reach_in",
                                            startAdornment: "",
                                            endAdornment: "枚",
                                            InputValueObj: props.storeOpeningConditions,
                                            ReadOnlyObj: storeOpeningConditionsReadOnlyObj,
                                            setReadOnlyObj: setStoreOpeningConditionsReadOnlyObj,
                                            ShowEditIconObj: initStoreOpeningConditionsShowEditIconObj,
                                            ShowIconsObj: storeOpeningConditionsShowIconsObj,
                                            handleChatBubbleClick: handleChatBubbleClick,
                                            handleInputBlur: handleInputBlur,
                                            handleInputChange: handleInputChange,
                                            handleInputClick: handleInputClick,
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid container spacing={2} maxWidth="lg">
                        <Grid xs={12} md={6}>
                            <Grid container spacing={2} alignItems="center">
                                <Grid>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            width: "180px",
                                        }}
                                    >
                                        <Typography>ウォークイン</Typography>
                                        <RedAsterisk>＊＊</RedAsterisk>
                                    </Box>
                                </Grid>
                                <Grid sx={itemValueSx}>
                                    <InputWithIcons
                                        props={{
                                            userType: userType, //ユーザー
                                            disabled: setPermissionFunc(
                                                userType,
                                                objLocationBase.task_id,
                                                LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                                "walk_in"
                                            ), //ユーザー権限
                                            pageName: LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                            labelName: "walk_in",
                                            startAdornment: "",
                                            endAdornment: "枚",
                                            InputValueObj: props.storeOpeningConditions,
                                            ReadOnlyObj: storeOpeningConditionsReadOnlyObj,
                                            setReadOnlyObj: setStoreOpeningConditionsReadOnlyObj,
                                            ShowEditIconObj: initStoreOpeningConditionsShowEditIconObj,
                                            ShowIconsObj: storeOpeningConditionsShowIconsObj,
                                            handleChatBubbleClick: handleChatBubbleClick,
                                            handleInputBlur: handleInputBlur,
                                            handleInputChange: handleInputChange,
                                            handleInputClick: handleInputClick,
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid xs={12} md={6}>
                            <Grid container spacing={2} alignItems="center">
                                <Grid>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            width: "180px",
                                        }}
                                    >
                                        <Typography>カウンター幅</Typography>
                                        <RedAsterisk>＊＊</RedAsterisk>
                                    </Box>
                                </Grid>
                                <Grid sx={itemValueSx}>
                                    <InputWithIcons
                                        props={{
                                            userType: userType, //ユーザー
                                            disabled: setPermissionFunc(
                                                userType,
                                                objLocationBase.task_id,
                                                LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                                "conter_width"
                                            ), //ユーザー権限
                                            pageName: LOCAL_CONSTANT.NAVI.STORE_OPENING_CONDITIONS,
                                            labelName: "conter_width",
                                            startAdornment: "",
                                            endAdornment: "m",
                                            InputValueObj: props.storeOpeningConditions,
                                            ReadOnlyObj: storeOpeningConditionsReadOnlyObj,
                                            setReadOnlyObj: setStoreOpeningConditionsReadOnlyObj,
                                            ShowEditIconObj: initStoreOpeningConditionsShowEditIconObj,
                                            ShowIconsObj: storeOpeningConditionsShowIconsObj,
                                            handleChatBubbleClick: handleChatBubbleClick,
                                            handleInputBlur: handleInputBlur,
                                            handleInputChange: handleInputChange,
                                            handleInputClick: handleInputClick,
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Box>
            )}

            {/*不備コメント モーダル画面 */}
            <DeficiencyCommentRegistModal
                props={{
                    userType: userType,
                    modalOpen: deficiencyComentModalFlag,
                    setModalOpen: setDeficiencyComentModalFlag,
                    CommentTextFieldObj: storeOpeningConditionsCommentTextFieldObj,
                    tableName: LOCAL_CONSTANT.TABLE.STORE_OPENING_CONDITIONS,
                    columnName: labelNameStr,
                    subKey: LOCAL_CONSTANT.DEFICIENCY.DEFAULT_SUB_KEY,
                    handleCommentChange: handleCommentChange,
                    handleSaveComment: handleSaveComment,
                }}
            />
        </Box>
    );
};

export default SpecialNotes;
